import React, { createContext, useState, useContext } from "react";
import { API_BASE_URL } from "../utils/constants";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const decorateUser = (value) => {
    if (!value) {
        return null;
    }

    const userArray = Array.isArray(value) ? [...value] : [value];
    const primaryUser = userArray[0] || {};

    // Map from camelCase API response to both formats
    const userName = primaryUser.userName || primaryUser.User_name;
    const userType = primaryUser.userType || primaryUser.User_type;
    const refId = primaryUser.refId || primaryUser.Ref_id;
    const role = primaryUser.role || primaryUser.Role;

    userArray[0].User_name = userName;
    userArray[0].User_type = userType;
    userArray[0].Ref_id = refId;
    userArray[0].Role = role;
    userArray[0].userName = userName;
    userArray[0].userType = userType;
    userArray[0].refId = refId;
    userArray[0].role = role;

    return userArray;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem("user");
        return savedUser ? decorateUser(JSON.parse(savedUser)) : null;
    });

    const login = async (credentials) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/users`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(credentials),
            });
            const data = await response.json();
            if (response.status === 200) {
                const normalizedUser = decorateUser(data);
                setUser(normalizedUser);
                localStorage.setItem("user", JSON.stringify(data));
                return normalizedUser;
            } else {
                // The server's reason: wrong username / password, or too many wrong tries ("Try again in N minutes")
                throw new Error(data?.message || "Invalid username or password");
            }
        } catch (error) {
            throw new Error(error.message);
        }
    };

    // console.log(user);

    const logout = () => {
        setUser(null);
        localStorage.removeItem("user");
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
